import { render } from "./MatterAnimation.vue?vue&type=template&id=5288fd32&scoped=true"
import script from "./MatterAnimation.vue?vue&type=script&lang=js"
export * from "./MatterAnimation.vue?vue&type=script&lang=js"

import "./MatterAnimation.vue?vue&type=style&index=0&id=5288fd32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5288fd32"]])

export default __exports__